<template>
  <div class="special-view">
    <v-card class="note" v-if="showSpecialReview">
      <v-card-text>
        <v-layout raw class="m-auto">
          <v-flex lg11>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>Correction Code:</strong></v-flex>
              <v-flex lg3 class="flex-item">{{ returnCode }}</v-flex>
              <v-flex lg3 class="flex-item"><strong>Received Time:</strong></v-flex>
              <v-flex lg4 class="flex-item">{{ returnedAt }}</v-flex>
            </v-layout>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>Transaction No:</strong></v-flex>
              <v-flex lg4 class="flex-item">{{ returnData.transactionNo }}</v-flex>
            </v-layout>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>Return Data:</strong></v-flex>
              <v-flex lg3 class="flex-item">
                <v-btn text small lg3 class="flex-item rounded-0 return-data-style" @click="returnDataDialogShow = true"><strong>Details</strong></v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg1>
            <template>
              <v-btn text class="resolve" @click="resolve" v-if="isLockedByCurrentUser()">Resolve</v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="note" v-if="showMoreSpecialReview">
      <v-card-text>
        <v-layout raw class="m-auto">
          <v-flex lg1 class="more">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" dark color="#FFB343">
                  <v-icon>pending</v-icon>
                </v-btn>
              </template>
              <span>More</span>
            </v-tooltip>
          </v-flex>
          <v-flex lg10>
            <v-layout raw>
              <v-flex lg4 class="flex-item"><strong>Correction Code:</strong></v-flex>
              <v-flex lg3 class="flex-item">{{ returnCode }}</v-flex>
            </v-layout>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>Received Time:</strong></v-flex>
              <v-flex lg5 class="flex-item">{{ returnedAt }}</v-flex>
            </v-layout>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>TransactionNo:</strong></v-flex>
              <v-flex lg3 class="flex-item">{{ returnData.transactionNo }}</v-flex>
            </v-layout>
            <v-layout raw>
              <v-flex lg3 class="flex-item"><strong>Return Data:</strong></v-flex>
              <v-flex lg3 class="flex-item">
                <v-btn text small flat lg3 class="flex-item rounded-0 return-data-style" @click="returnDataDialogShow = true"><strong>Details</strong></v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg1>
            <v-btn text class="resolve2" @click="resolve" v-if="isLockedByCurrentUser()">Resolve</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="returnDataDialogShow" persistent width="30%">
      <v-card>
        <v-card-title style="background: #41a7f2 !important; color: #fff;">
          Return Data
          <v-spacer></v-spacer>
          <v-btn icon @click="returnDataDialogShow = false" color="#fff">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions  v-for="(item, value) in returnData" :key="value">
          <v-row>
            <v-col cols="6" class="title-flex">
              {{value}}
            </v-col>
            <v-col cols="6">
              <v-text-field hide-details dense disabled :value="item" class="p-0 m-0">{{ item }}</v-text-field>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="returnDataDialogShow = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ProcessingApi } from '@/api/pandaria'
import { Crypto, Tool, DataType, Authentication } from '@/util/index'
const tool = new Tool()
export default {
  name: 'special-view',
  props: {
    loan: {
      type: Object,
      default: () => {}
    },
    slaveLoanId: Number,
    currentLockedId: Number
  },
  data () {
    return {
      showSpecialReview: false,
      showMoreSpecialReview: false,
      returnCode: '',
      returnedAt: '',
      returnData: {},
      descriptionData: '',
      resolveId: 0,
      specialReviewResult: [],
      returnDataDialogShow: false
    }
  },
  computed: {
    loanId () {
      return parseInt(Crypto.decrypt(this.$route.params.uuid), 10)
    }
  },
  watch: {
    loan (val) {
      const $this = this
      $this.loanType = val.loanType
      if ($this.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value) {
        $this.initSpecialReview($this.loanId)
      }
    },
    slaveLoanId (val) {
      this.initSpecialReview(val)
    }
  },
  methods: {
    initSpecialReview (id) {
      const $this = this
      const requestData = {
        loanId: id
      }
      ProcessingApi.getSpecialReview(requestData, function (result) {
        if (tool.isNotEmpty(result) && result.length !== 0) {
          $this.$eventBus.$emit('showSpecial', true)
          if (result.length === 1) {
            $this.showSpecialReview = true
          } else if (result.length > 1) {
            $this.showMoreSpecialReview = true
            $this.specialReviewResult = result
          }
          $this.resolveId = result[0].id
          result = JSON.parse(result[0].content)
          $this.returnCode = result.returnCode
          $this.returnedAt = tool.formatDateTime(result.returnedAt)
          $this.returnData = JSON.parse(result.returnData)
          $this.descriptionData = $this.returnData.returnDescription
        } else {
          $this.$eventBus.$emit('showSpecial', false)
        }
      }, function () {
        $this.$eventBus.$emit('showSpecial', false)
      })
    },
    resolve () {
      const $this = this
      ProcessingApi.resolveSpecialReview($this.resolveId, function (result) {
        if ($this.showSpecialReview === true) {
          $this.showSpecialReview = false
        } else if ($this.showMoreSpecialReview === true) {
          $this.showMoreSpecialReview = false
          $this.specialReviewResult.shift()
          if ($this.specialReviewResult.length === 1) {
            $this.showSpecialReview = true
          } else if ($this.specialReviewResult.length > 1) {
            $this.showMoreSpecialReview = true
          }
          $this.resolveId = $this.specialReviewResult[0].id
          result = JSON.parse($this.specialReviewResult[0].content)
          $this.returnCode = result.returnCode
          $this.returnedAt = tool.formatDateTime(result.returnedAt)
          $this.returnData = JSON.parse(result.returnData)
          $this.descriptionData = $this.returnData.returnDescription
        }
      })
    },
    isLockedByCurrentUser () {
      return Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    copyData (copyText) {
      const oInput = document.createElement('input')
      oInput.value = copyText
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('copy')
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      window._VMA.$emit('SHOW_SNACKBAR', {
        text: 'Copy Successfully.',
        color: 'success'
      })
    }
  },
  destroyed () {
    this.$eventBus.$off('showSpecial')
  }
}
</script>
<style scoped>
  .resolve {
    color: #804c00;
    font-weight: bolder;
    font-size: 16px;
    margin: 0 -16px -16px -60px;
    border-radius: 2px;
    height: 24px !important;
  }
  .resolve:hover {
    background-color: #FFB343;
    padding: 20px 16px;
  }
  .resolve2 {
    color: #804c00;
    font-weight: bolder;
    font-size: 16px;
    margin: 0 -16px -16px -48px;
    border-radius: 2px;
    height: 24px !important;
  }
  .resolve2:hover {
    background-color: #FFB343;
    padding: 20px 16px;
  }

  .note {
    background-color: #FFE5BF;
    border-color: #FF9800;
    color: #804c00;
  }
  .note-icon {
    background-color: #FF9800;
    width: 100px;
    font-size: 56px;
    line-height: 87px;
    text-align: center;
    margin: -18px 20px -18px -36px;
  }
  .flex-item {
    padding: 0 !important;
    color: #804c00;
    height: 22px;
  }
  .return-data {
    position: absolute;
    top: -18px;
    left: 0px;
  }

  .note .v-card__text {
    padding: 5px 16px !important;
  }

  .more {
    padding: 0px !important;
    margin: 2px 0px 0px -10px;
  }
  .description-data {
    position: absolute;
    width:125px;
    max-width: 125px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .copy-description-data-btn {
    margin-left: 125px;
    padding-bottom: 5px;
  }
  .copy-return-data-btn {
    margin-left: 125px;
    padding-bottom: 5px;
  }
  .return-data-style {
    color: #804c00;
    height: 24px !important;
    background-color: #FFB343;
  }
  .return-data-style:hover {
    background-color: #FFB343;
    padding: 20px 16px;
  }
  .title-flex {
    display: flex;
    align-items: flex-end;
  }
  </style>
